import Vue from 'vue';
import App from './App.vue';
import router from './router';
import 'vant/lib/index.css';
import { Icon } from 'vant';

Vue.use(Icon);

// 运行时覆盖字体路径

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
